
import { Component, Prop, Vue } from "vue-property-decorator";
import LINE_1 from "@/components/V2/StartSWBanner/StartSWBanner_line-1.png";
import LINE_2 from "@/components/V2/StartSWBanner/StartSWBanner_line-2.png";
import { SMAdditionalInfo } from "@/store";

@Component
export default class StartSWBanner extends Vue {
  @Prop({ type: [Object, String], default: () => ({}) }) readonly src: object;
  @Prop({ type: Boolean, default: false }) readonly short: boolean;
  @Prop({ type: String, default: null }) readonly type: string;

  LINE_1 = LINE_1;
  LINE_2 = LINE_2;

  get buttonLabel() {
    return this.$tc("button");
  }

  get title() {
    return this.$tc("title");
  }

  get text() {
    return this.$tc("text");
  }

  action() {
    SMAdditionalInfo.inviteCandidate();
  }

  get stepOneLabel() {
    return `${this.$t("picture.step_label")} 1: `;
  }

  get stepOneValue() {
    return this.$t("picture.step_1");
  }

  get stepTwoLabel() {
    return `${this.$t("picture.step_label")} 2: `;
  }

  get stepTwoValue() {
    return this.$t("picture.step_2");
  }
}
